import { Vue } from "vue-property-decorator";
import VueI18n from "vue-i18n";

import br from "./br";
import en from "./en";
import es from "./es";
// import ma from "./ma";

Vue.use(VueI18n);

const messages = {
	br,
	en,
	es,
	// ma,
};

const i18n = new VueI18n({
	locale: "br", // set locale
	fallbackLocale: "br", // set fallback locale
	messages, // set locale messages
});

export default i18n;
